/**
 * 运费汇款单 内容 俄文
 * Author:  Fjj
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/9/16      1.0     FJJ
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from 'react';
import {toFixed2} from '@utils/utils';
import "../Bill.less";

export default class TableFreightRemittanceRu extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            orderInfo: {},

            loading: false,
        }
    }
    render(){
        const {orderInfo,  } = this.props;
        return ( <div className="padding-top-10 padding-bottom-10 color-black">
            <div className={"text-center font-bold"}>
                {/* 柜号 */}
                <p>АКТ</p>
                <p className="margin_bottom_20">сдачи-приемки услуг<span className={"margin-l-r-5 color-danger"}>{orderInfo.cabinetNumRu}</span></p>
                {/* 合同号和日期 */}
                <p className="font-16">к контракту №<span className={"margin-l-r-5 color-danger"}>{orderInfo.contractCodeRu}</span>(далее – Договор)</p>
            </div>
            {/* 日期 */}
            <p className="font-16 margin-top-md color-danger text-right">{orderInfo.dateRu}</p>
            {/* 描述 */}
            <p>
                Компания FANRONG E-COMMERCE CO., LIMITED, в лице директора г-жа Проскурниковой Анны, далее именуемого «Исполнитель» с одной стороны, и компании ООО «ЭССАВАН» (Россия), в лице генерального директора Вовк Татьяна Анатольевна, действующего на основании Устава, именуемого в дальнейшем «Заказчик», с другой стороны, (далее вместе – Стороны), составили настоящий Акт о нижеследующем:
            </p>
            <p>
                В соответствии с заключенным Договором Исполнитель оказал следующие услуги:
            </p>
            <table className={"table-border"}>
                <tbody>
                    <tr>
                        <th width="100">№ п/п</th>
                        <th>Наименование услуги</th>
                    </tr>
                    <tr>
                        <td></td>
                        <td className={"color-black font-bold"}>{orderInfo.descRu}</td>
                    </tr>
                </tbody>
            </table>
            <p className={"padding-bottom-10"}>слуги оказаны Исполнителем своевременно, в полном объеме, с соблюдением условий Договора</p>
            <p className={"padding-bottom-10"}>Стороны взаимных претензий друг к другу не имеют.</p>
            {/* 总运费 */}
            <div>За оказанные услуги Заказчик оплачивает Исполнителю денежные средства в размере
                <span className={"font-bold color-danger margin-l-r-5"}>{orderInfo.totalPriceRu}</span>CNY </div>
        </div>)
    }
}
